var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsPlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19844 20.3003C4.54279 19.9146 6.85628 18.0977 8.00619 17.202C8.425 16.8757 8.93871 16.7003 9.46958 16.7003C10.7532 16.7003 13.2268 16.7003 14.5167 16.7003C15.0538 16.7003 15.5726 16.8832 16.005 17.2017C17.4898 18.2956 18.8817 19.1106 20.3984 20.3003M5.99844 22.1H17.9984C19.9867 22.1 21.5984 20.4882 21.5984 18.5V6.50002C21.5984 4.5118 19.9867 2.90002 17.9984 2.90002H5.99844C4.01021 2.90002 2.39844 4.5118 2.39844 6.50002V18.5C2.39844 20.4882 4.01021 22.1 5.99844 22.1ZM15.437 9.77206C15.437 7.94055 13.8909 6.44411 11.9984 6.44411C10.1061 6.44411 8.55989 7.94055 8.55989 9.77206C8.55989 11.6036 10.1061 13.1 11.9984 13.1C13.8908 13.1 15.437 11.6036 15.437 9.77206Z",
    stroke: "#92929D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsPlatform);
export default __webpack_public_path__ + "static/media/DetailsPlatform.48bd8370e2e96d6d7133fb490b6ccfea.svg";
export { ForwardRef as ReactComponent };